module.exports = __webpack_public_path__ + "img/kopiarka-static.541d3818.png";